import { render } from "./ContulMeu.vue?vue&type=template&id=4db15362&scoped=true"
import script from "./ContulMeu.vue?vue&type=script&lang=js"
export * from "./ContulMeu.vue?vue&type=script&lang=js"

import "./ContulMeu.vue?vue&type=style&index=0&id=4db15362&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db15362"]])

export default __exports__